/* eslint-disable no-nested-ternary */
export function Stepper({
  steps,
  currentStep,
}: {
  steps: string[];
  currentStep: number;
}) {
  return (
    <div className='flex items-center space-x-4'>
      {steps.map((step, index) => (
        <div key={step} className='flex items-center'>
          {/* Step Circle */}
          <div
            className={`flex items-center justify-center w-10 h-10 rounded-full border-2 text-base leading-6 font-semibold font-inter ${
              index + 1 === currentStep
                ? 'border-primary text-gray-950 bg-gray-100'
                : index + 1 < currentStep
                ? 'bg-primary text-white border-primary'
                : 'border-gray-200 text-gray-500 bg-gray-100'
            }`}
          >
            {index + 1}
          </div>
          {/* Step Name */}
          <span
            className={`ml-3 text-base leading-6 font-medium font-inter ${
              index + 1 === currentStep
                ? 'text-gray-950'
                : index + 1 < currentStep
                ? 'text-primary'
                : 'text-gray-500'
            }`}
          >
            {step}
          </span>
          {/* Right Arrow */}
          {index < steps.length - 1 && (
            <svg
              className='ml-4 w-5 h-5 text-gray-300'
              fill='currentColor'
              viewBox='0 0 20 20'
              aria-hidden='true'
            >
              <path d='M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 011.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z' />
            </svg>
          )}
        </div>
      ))}
    </div>
  );
}
